// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/dutch-roll-and-spiral-instability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/dutch-roll-and-spiral-instability/dutch-roll-and-spiral-instability.js';

mount([g0]);
